import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.html',
  styleUrl: './hero.scss',
})
export class Hero {
  environment = environment;
  hero: any = environment.HeroConfig;
  booking: any = environment.BookingConfig;

  constructor() {
    document.documentElement.style.setProperty(
      '--hero-img',
      `url('${this.hero.imgUrl}')`
    );
  }
}


